import { ActionReducerMapBuilder } from "@reduxjs/toolkit";

import { IMembersInitialState } from "./member.interfaces";

import {
  addMemberAsync,
  approuveAccountAsync,
  banProfileAsync,
  deleteAccountAsync,
  disApprouveAccountAsync,
  editMemberAsync,
  getFilteredProfilesAsync,
  getListAccountsMember,
  getListDeletedAccountsMember,
  getListPendingAccountsMember,
  getListSubscriptionsAsync,
  getListWarningMembersAsync,
  getModeratedMessagesAsync,
  getNbUnhandledReportsAsync,
  manuallyConfirmEmailAsync,
  marckAsHandledAsync,
  refreshStatusAsync,
  resetMemberPasswordAsync,
  restoreMemberAccountAsync,
  switchProfileToFreeAsync,
  toggleAccountActivenessAsync,
  unbanProfileAsync,
  validateAllReviewsAsync,
} from "./member.services";

import {
  IApiGet,
  IAPIResponseGetAllProfiles,
} from "@/features/backoffice/types";
import { errorInitialValue } from "./member.slice";

const asyncActions = (
  builder: ActionReducerMapBuilder<IMembersInitialState>
) => {
  builder.addCase(getFilteredProfilesAsync.pending, (state) => {
    state.loading = "pending";
    state.errors = errorInitialValue;
  });

  builder.addCase(getFilteredProfilesAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listProfiles = action.payload;
  });

  builder.addCase(getFilteredProfilesAsync.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(getListAccountsMember.pending, (state) => {
    state.loading = "pending";
    state.errors = errorInitialValue;
  });

  builder.addCase(getListAccountsMember.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    const payload: IApiGet<IAPIResponseGetAllProfiles> = action.payload as any;
    state.listProfiles = payload.data;
  });

  builder.addCase(getListAccountsMember.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(getListPendingAccountsMember.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listPendingProfiles = {
      ...action.payload,
      // data: action.payload.data.filter((data) => data.rate_of_completion >= 10),
    };
  });

  builder.addCase(getModeratedMessagesAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listModeratedMessages = action.payload;
  });

  builder.addCase(getModeratedMessagesAsync.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(getListPendingAccountsMember.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(getListWarningMembersAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listWarningAccounts = action.payload;
  });

  builder.addCase(getListWarningMembersAsync.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(getListDeletedAccountsMember.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listDeletedAccounts = action.payload;
  });

  builder.addCase(getListDeletedAccountsMember.rejected, (state, action) => {
    state.loading = "failed";
    state.errors = action.payload;
  });

  builder.addCase(approuveAccountAsync.fulfilled, (state, action) => {
    const profile = state.listPendingProfiles?.data.result.find(
      (member) => member._id === action.meta.arg.id
    );

    let currentStatus;
    let newStatus;

    if (profile) {
      currentStatus = profile.status.value;
      newStatus = action.payload.data.status.value;

      const index = state.listPendingProfiles?.data.result.findIndex(
        (member) => member._id === action.meta.arg.id
      );

      if (index !== -1 && currentStatus !== newStatus) {
        state.listPendingProfiles?.data.result.splice(index!, 1);

        if (state.listPendingProfiles?.data.paginationResult) {
          if (state.listPendingProfiles.data.paginationResult.count > 0) {
            state.listPendingProfiles.data.paginationResult.count -= 1;
          }
          if (state.listPendingProfiles.data.paginationResult.totalCount > 0) {
            state.listPendingProfiles.data.paginationResult.totalCount -= 1;
          }
        }
      }

      if (state.listPendingProfiles?.data.countStatus) {
        if (currentStatus !== newStatus) {
          if (
            currentStatus === "VALIDATED_EDITED" ||
            currentStatus === "NEW_EDITED" ||
            currentStatus === "REJECTED_EDITED"
          ) {
            if (state.listPendingProfiles.data.countStatus[currentStatus] > 0) {
              state.listPendingProfiles.data.countStatus[currentStatus] -= 1;
            }
          }

          if (newStatus === "REJECTED") {
            state.listPendingProfiles.data.countStatus.REJECTED += 1;
          }
        }
      }
    }
  });

  builder.addCase(disApprouveAccountAsync.fulfilled, (state, action) => {
    if (state.listPendingProfiles) {
      // state.listPendingProfiles.data = state.listPendingProfiles.data.map(
      //   (member) =>
      //     member.id === action.payload.id
      //       ? {
      //           ...member,
      //           is_reviewed: true,
      //           account: { ...member.account, changes_requests_updated: false },
      //         }
      //       : member
      // );
    }
  });

  builder.addCase(deleteAccountAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      state.listProfiles.result = state.listProfiles.result.filter(
        (member) => member.member._id !== action.meta.arg.id
      );
    }
  });

  builder.addCase(toggleAccountActivenessAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      const index = state.listProfiles.result.findIndex(
        (member) => member._id === action.payload.data._id
      );

      state.listProfiles.result[index].activation.isActivate =
        action.payload.data.activation.isActivate;

      // if (typeof action.meta.arg.reason === "string") {
      //   state.listProfiles.result[index].activation.reason =
      //     action.meta.arg.reason;
      // } else if (
      //   state.listProfiles.result[index].activation.reason !== undefined
      // ) {
      //   state.listProfiles.result[index].activation.reason = null;
      // }

      // state.listProfiles.result[index].activation.isActivate = action.payload.data.activation.isActivate;
    }
  });

  builder.addCase(banProfileAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      const index = state.listProfiles.result.findIndex(
        (member) => member.member._id === action.meta.arg.id
      );

      if (index != -1) {
        state.listProfiles.result[index].member.isBanned = action.payload.data;
      }
    }
  });

  builder.addCase(unbanProfileAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      const index = state.listProfiles.result.findIndex(
        (member) => member.member._id === action.meta.arg
      );

      if (index != -1) {
        console.log(index + " " + action.payload.data);
        state.listProfiles.result[index].member.isBanned = action.payload.data;
      }
    }
  });

  builder.addCase(switchProfileToFreeAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      const index = state.listProfiles.result.findIndex(
        (member) => member._id === action.payload.data._id
      );

      state.listProfiles.result[index] = action.payload.data;
      // state.listProfiles.result = state.listProfiles.result.map((profile) =>
      //   profile._id === action.payload._id ? action.payload : profile
      // );
      // const index = state.listProfiles.result.findIndex(
      //   (member) => member._id === action.payload.
      // );
    }
  });

  builder.addCase(resetMemberPasswordAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      // const index = state.listProfiles.data.findIndex(
      //   (member) => member.id === action.meta.arg
      // );
      // state.listProfiles.data[index] = {
      //   ...state.listProfiles.data[index],
      //   ...action.payload,
      // };
    }
  });

  builder.addCase(restoreMemberAccountAsync.fulfilled, (state, action) => {
    if (state.listDeletedAccounts) {
      state.listDeletedAccounts.data.result =
        state.listDeletedAccounts.data.result.filter(
          (member) => member._id !== action.meta.arg
        );
      state.listDeletedAccounts.data.paginationResult.totalCount -= 1;
    }
  });

  builder.addCase(addMemberAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      state.listProfiles.result = [
        action.payload.data,
        ...state.listProfiles.result,
      ];
    }
  });

  builder.addCase(editMemberAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      // state.listProfiles.data = state.listProfiles.data.map((profile) =>
      //   profile.id === action.payload.id ? action.payload : profile
      // );
      // state.listProfiles.data = [
      //   action.payload.data,
      //   ...state.listProfiles.data,
      // ];
    }
  });

  builder.addCase(marckAsHandledAsync.fulfilled, (state, action) => {
    state.nbUnhandledReports = state.nbUnhandledReports - 1;
    if (state.listReportedAccounts) {
      const index = state.listReportedAccounts.data.result.findIndex(
        (member) => member.id === action.payload.data._id
      );

      if (index !== -1) {
        state.listReportedAccounts.data.result[index] = {
          ...state.listReportedAccounts.data.result[index],
          isHandled: action.payload.data.isHandled,
        };
      }
    }
  });

  builder.addCase(validateAllReviewsAsync.fulfilled, (state, action) => {
    const profile = state.listPendingProfiles?.data.result.find(
      (member) => member._id === action.meta.arg.id
    );

    if (profile) {
      const index = state.listPendingProfiles?.data.result.findIndex(
        (member) => member._id === action.meta.arg.id
      );

      if (index !== -1) {
        state.listPendingProfiles?.data.result.splice(index!, 1);
      }

      if (state.listPendingProfiles?.data.paginationResult) {
        if (state.listPendingProfiles.data.paginationResult.count > 0) {
          state.listPendingProfiles.data.paginationResult.count -= 1;
        }
        if (state.listPendingProfiles.data.paginationResult.totalCount > 0) {
          state.listPendingProfiles.data.paginationResult.totalCount -= 1;
        }
      }

      if (state.listPendingProfiles?.data.countStatus) {
        const status = profile.status.value;
        if (
          status === "VALIDATED_EDITED" ||
          status === "NEW_EDITED" ||
          status === "REJECTED_EDITED"
        ) {
          if (state.listPendingProfiles.data.countStatus[status] > 0) {
            state.listPendingProfiles.data.countStatus[status] -= 1;
          }
        }
        if (action.payload.data.status.value === "REJECTED") {
          state.listPendingProfiles.data.countStatus.REJECTED += 1;
        }
      }
    }
  });

  builder.addCase(getNbUnhandledReportsAsync.fulfilled, (state, action) => {
    state.nbUnhandledReports = action.payload.data;
  });

  builder.addCase(manuallyConfirmEmailAsync.fulfilled, (state, action) => {
    if (state.listProfiles) {
      const index = state.listProfiles.result.findIndex(
        (member) => member.member._id === action.meta.arg.id
      );

      if (index !== -1) {
        state.listProfiles.result[index] = {
          ...state.listProfiles.result[index],
          isEmailVerified: action.payload,
        };
      }
    }
  });

  builder.addCase(refreshStatusAsync.fulfilled, (state, action) => {
    if (state.listPendingProfiles) {
      const index = state.listPendingProfiles.data.result.findIndex(
        (member) => member._id === action.meta.arg.id
      );

      if (index !== -1) {
        const currentStatus =
          state.listPendingProfiles.data.result[index].status.value;
        const newStatus = action.payload.data.status.value;

        if (currentStatus !== newStatus) {
          state.listPendingProfiles?.data.result.splice(index!, 1);

          state.listPendingProfiles.data.countStatus[currentStatus] -= 1;

          if (action.payload.data.status.value === "REJECTED") {
            state.listPendingProfiles.data.countStatus.REJECTED += 1;
          } else if (action.payload.data.status.value === "REJECTED_EDITED") {
            state.listPendingProfiles.data.countStatus.REJECTED_EDITED += 1;
          } else if (action.payload.data.status.value === "VALIDATED_EDITED") {
            state.listPendingProfiles.data.countStatus.VALIDATED_EDITED += 1;
          } else if (action.payload.data.status.value === "NEW_EDITED") {
            state.listPendingProfiles.data.countStatus.NEW_EDITED += 1;
          }
        }
      }
    }
  });
  builder.addCase(getListSubscriptionsAsync.fulfilled, (state, action) => {
    state.loading = "idle";
    state.errors = errorInitialValue;
    state.listSubscriptions = action.payload;
  });

  // builder.addCase(deleteAccountAsync.fulfilled, (state, action) => {
  //   if (state.listProfiles) {
  //     state.listProfiles.result = state.listProfiles.result.filter(
  //       (member) => member._id !== action.meta.arg.id
  //     );
  //   }
  // })
};

export default asyncActions;
